import React from 'react'
import { Form, Modal, Typography } from 'antd'
import IntlMessages from '../../util/IntlMessages'
import SetPassword from '../set-password'
import * as logger from '../../services/logger'

const { Paragraph } = Typography

interface IForceChangePasswordModalProps {
  onSave: (newPassword: string) => Promise<void>
  onCancel: () => void
  isLoading: boolean
}

interface IForceChangePasswordFormValues {
  password: string
  repeatPassword: string
}

const ForceChangePasswordModal = ({ onSave, onCancel, isLoading }: IForceChangePasswordModalProps): React.ReactElement => {
  const [form] = Form.useForm<IForceChangePasswordFormValues>()

  const onFinish = () => {
    form
      .validateFields()
      .then((values) => {
        onSave(values.password)
      })
      .catch((info) => {
        logger.debug('ForceChangePassword validation failed:', info)
      })
  }

  return (
    <Modal
      open={true}
      closable={false}
      maskClosable={false}
      keyboard={false}
      confirmLoading={isLoading}
      onOk={onFinish}
      onCancel={onCancel}
      title={<IntlMessages id="modal.forceChangePassword.title" />}
      okText={<IntlMessages id="modal.forceChangePassword.submit" />}
      cancelText={<IntlMessages id="modal.forceChangePassword.cancel" />}
      cancelButtonProps={{ disabled: isLoading }}
    >
      <Paragraph>
        <IntlMessages id="modal.forceChangePassword.description" />
      </Paragraph>
      <Form key="ForceChangePasswordForm" form={form} name="ForceChangePasswordForm" layout="vertical" onFinish={onFinish}>
        <SetPassword />
      </Form>
    </Modal>
  )
}

export default ForceChangePasswordModal
